import React from 'react';
import { useTranslation } from 'react-i18next';
import KpiWidget from './KpiWidget';

const LeadsKpiWidget = ({ totalLeads = 0 }) => {
  const { t } = useTranslation();

  return (
    <KpiWidget
      label={t('dashboard.agent.leads')}
      value={totalLeads.toLocaleString()}
      hint={t('dashboard.currentWeek')}
    />
  );
};

export default LeadsKpiWidget;
